import { Typography } from '@design-system/components/typography/typography';
import * as styles from './FeatureSection.css';
import { Button } from '@design-system/components/button/button';
import { Col } from '@design-system/components/grid/grid';
import clsx from 'clsx';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

type FeatureSectionProps = {
  title: string;
  description: string;
  ctaText: string;
  onClick: () => void;
  imageSrc: string;
  reverse?: boolean;
  ctaLeftIcon?: IconProp;
  ctaColor?: 'primary' | 'neutral';
};

export const FeatureSection = (p: FeatureSectionProps) => {
  return (
    <div className={clsx(styles.wrapper)}>
      <Col gap="xl" className={styles.child}>
        <Typography variant="display" size="small">
          {p.title}
        </Typography>
        <Typography variant="title" size="large" className={styles.textWrapper}>
          {p.description}
        </Typography>
        <div>
          <Button
            variant="filled"
            color={p.ctaColor ?? 'primary'}
            onClick={p.onClick}
            leftIcon={p.ctaLeftIcon}
          >
            {p.ctaText}
          </Button>
        </div>
      </Col>
      <div
        className={clsx(styles.imageWrapper, p.reverse && styles.reverseImage)}
      >
        <img src={p.imageSrc} alt="" />
      </div>
    </div>
  );
};
